var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRozieLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 30,
    viewBox: "0 0 150 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.02 6.78052H147.77V6.99515H147.513V7.97076H147.266V6.99515H147.02V6.78052ZM148.421 7.63905L148.579 6.78052H148.914V8.00003H148.687V7.13174L148.539 8.00003H148.302L148.125 7.14149V8.00003H147.908V6.78052H148.243L148.421 7.63905Z",
    fill: "#241032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8188 21.4049V6.77076H49.5195C50.3848 6.76213 51.2378 6.9738 51.9965 7.3854C52.7355 7.77596 53.3582 8.35116 53.8024 9.05369C54.2714 9.7746 54.5151 10.6161 54.5031 11.4732C54.5038 12.3509 54.2125 13.2046 53.6741 13.9025C53.1209 14.6486 52.3645 15.2238 51.4932 15.561L55.1642 21.4147H52.2037L48.8781 15.922H45.2662V21.4147L42.8188 21.4049ZM45.2465 13.7366H49.7267C50.0301 13.7452 50.3318 13.6906 50.6123 13.5763C50.8929 13.462 51.1459 13.2906 51.355 13.0732C51.5681 12.8528 51.7346 12.5926 51.8448 12.3078C51.9549 12.023 52.0065 11.7194 51.9965 11.4147C52.0069 11.0764 51.9385 10.7403 51.7965 10.4324C51.6544 10.1245 51.4426 9.85303 51.1774 9.63905C50.5943 9.16866 49.857 8.92571 49.105 8.95613H45.2662L45.2465 13.7366Z",
    fill: "#241032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7369 21.6194C66.6866 21.6276 65.6445 21.4355 64.6678 21.0536C63.7552 20.6903 62.9236 20.1533 62.2204 19.4731C61.5138 18.8001 60.956 17.9895 60.5823 17.0926C60.1922 16.1417 59.9977 15.1235 60.0099 14.0975C59.9966 13.0682 60.1912 12.0466 60.5823 11.0926C60.9526 10.1987 61.5033 9.38872 62.2007 8.71212C62.9039 8.03189 63.7354 7.49489 64.6481 7.13163C66.623 6.37735 68.8113 6.37735 70.7862 7.13163C71.6987 7.49959 72.53 8.03972 73.2336 8.72188C73.9259 9.40639 74.4758 10.2185 74.852 11.1121C75.6148 13.0276 75.6148 15.1576 74.852 17.0731C74.4758 17.9668 73.9259 18.7788 73.2336 19.4633C72.53 20.1455 71.6987 20.6856 70.7862 21.0536C69.8155 21.4323 68.7805 21.6244 67.7369 21.6194ZM67.7369 19.4243C68.6883 19.4408 69.6263 19.2014 70.4507 18.7316C71.2428 18.2641 71.8884 17.5887 72.3158 16.7804C72.7742 15.9423 73.0053 15.0013 72.9869 14.0487C73.0066 13.0929 72.7754 12.1484 72.3158 11.3072C71.8884 10.499 71.2428 9.82361 70.4507 9.35602C69.6236 8.90155 68.693 8.66305 67.7468 8.66305C66.8005 8.66305 65.8699 8.90155 65.0428 9.35602C64.2656 9.81004 63.6278 10.4642 63.1974 11.2487C62.7324 12.0917 62.4977 13.0399 62.5165 13.9999C62.4989 14.9567 62.7336 15.9015 63.1974 16.7414C63.6278 17.5259 64.2656 18.1801 65.0428 18.6341C65.8519 19.1337 66.7831 19.4068 67.7369 19.4243Z",
    fill: "#241032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5757 21.4049V19.7561L89.25 8.95613H81.1579V6.78052H92.5559V8.40979L83.9211 19.2781H92.8027V21.4439L80.5757 21.4049Z",
    fill: "#241032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6313 21.4049V19.2781H102.177V8.86832H99.6313V6.78052H107.141V8.86832H104.595V19.2781H107.141V21.3659L99.6313 21.4049Z",
    fill: "#241032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.523 21.4049V6.77075H124.391V8.94636H116.911V12.8488H123.158V15.0244H116.911V19.2781H124.391V21.4439L114.523 21.4049Z",
    fill: "#241032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.339 14.4488L134.595 6.78052H136.017L139.214 14.4488H137.556L136.845 12.683H133.609L132.888 14.4488H131.339ZM134.595 10.1073L134.072 11.4732H136.382L135.819 10.0878L135.671 9.67808C135.602 9.49271 135.533 9.28784 135.454 9.06344L135.237 8.43906C135.148 8.72198 135.04 9.01466 134.931 9.32686C134.822 9.63906 134.714 9.89271 134.595 10.1073Z",
    fill: "#241032"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.158 14.4488V13.1903H142.49V8.03905H141.148V6.78052H145.372V8.03905H144.01V13.1903H145.372V14.4488H141.158Z",
    fill: "#241032"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2695 21.8635C29.0006 22.8048 28.4281 23.6335 27.6389 24.2235C26.8497 24.8135 25.8872 25.1324 24.8978 25.1318C24.532 25.1347 24.1673 25.0921 23.8123 25.0049C23.2193 24.8821 22.6644 24.6213 22.1938 24.244C21.7654 23.9274 21.3977 23.5375 21.1083 23.0927L20.8715 22.7513L18.4044 18.8976C17.943 18.0293 17.3065 17.2636 16.5343 16.6478C15.762 16.032 14.8704 15.5791 13.9142 15.3171C12.2946 15.8562 10.5639 15.9837 8.88135 15.6879L13.8156 24.0586C17.9603 30.8879 29.082 29.8342 29.3583 21.6293C29.3329 21.7089 29.3032 21.787 29.2695 21.8635Z",
    fill: "#844D9E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.2695 21.8635C29.0006 22.8048 28.4281 23.6335 27.6389 24.2235C26.8497 24.8135 25.8872 25.1324 24.8978 25.1318C24.532 25.1347 24.1673 25.0921 23.8123 25.0049C23.2193 24.8821 22.6644 24.6213 22.1938 24.244C21.7654 23.9274 21.3977 23.5375 21.1083 23.0927L20.8715 22.7513L18.4044 18.8976C17.943 18.0293 17.3065 17.2636 16.5343 16.6478C15.762 16.032 14.8704 15.5791 13.9142 15.3171C12.2946 15.8562 10.5639 15.9837 8.88135 15.6879L13.8156 24.0586C17.9603 30.8879 29.082 29.8342 29.3583 21.6293C29.3329 21.7089 29.3032 21.787 29.2695 21.8635Z",
    fill: "url(#paint0_linear_87_25032)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.996582 5.84386V17.4536C0.996582 21.7756 5.27948 23.4829 7.79592 23.4829V4.64386C7.03778 4.38262 6.24024 4.25066 5.43737 4.25362C3.8123 4.2412 2.23663 4.80544 0.996582 5.84386Z",
    fill: "#844D9E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0.996582 5.84386V17.4536C0.996582 21.7756 5.27948 23.4829 7.79592 23.4829V4.64386C7.03778 4.38262 6.24024 4.25066 5.43737 4.25362C3.8123 4.2412 2.23663 4.80544 0.996582 5.84386Z",
    fill: "url(#paint1_linear_87_25032)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8945 15.3171C15.1162 14.905 16.1875 14.1453 16.974 13.1334C17.7606 12.1215 18.2273 10.9025 18.3156 9.62929C18.4537 4.17563 14.3682 0.975635 9.43398 0.975635C7.71652 0.970204 6.02895 1.41981 4.54683 2.27769C3.0647 3.13557 1.84215 4.37038 1.00635 5.85368C2.24077 4.80117 3.81703 4.22286 5.44714 4.22442C6.25001 4.22145 7.04755 4.35341 7.80569 4.61466C9.02215 5.03362 10.0693 5.82971 10.7912 6.88444C11.5131 7.93916 11.8712 9.19615 11.8123 10.4683C11.7734 11.5042 11.4843 12.5158 10.9693 13.4187C10.4543 14.3216 9.72821 15.0896 8.85174 15.6586C10.535 15.9655 12.2693 15.8481 13.8945 15.3171Z",
    fill: "#844D9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.898 23.5317C26.5058 23.5317 27.8092 22.2432 27.8092 20.6537C27.8092 19.0642 26.5058 17.7756 24.898 17.7756C23.2902 17.7756 21.9868 19.0642 21.9868 20.6537C21.9868 22.2432 23.2902 23.5317 24.898 23.5317Z",
    fill: "#5759A7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_25032",
    x1: 20.4669,
    y1: 20.9562,
    x2: 14.3846,
    y2: 10.3786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DEDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7F7D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3A3738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_25032",
    x1: 4.53934,
    y1: 19.1512,
    x2: 4.16319,
    y2: -3.24897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#6C696A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRozieLogo);
export default __webpack_public_path__ + "static/media/rozie-logo.78f7973a474c022d77129734ec69a5d7.svg";
export { ForwardRef as ReactComponent };